<template>
  <div
    class="article-card article-card--skeleton"
    :class="articleClass"
  >
    <div class="article-card__body mt-2">
      <USkeleton class="article-card__header w-2/3" />
      <USkeleton class="article-card__header w-full" />
      <USkeleton class="article-card__header w-3/5" />
    </div>

    <USkeleton class="article-card__aside"/>

    <USkeleton class="article-card__gallery"/>

    <div class="flex flex-row gap-2">
      <USkeleton class="article-card--skeleton-item h-12 w-12" :ui="{ rounded: 'rounded-full' }" />
      <div class="flex flex-col flex-grow gap-2">
        <USkeleton class="article-card__text w-1/5" />
        <USkeleton class="article-card__text w-2/5" />
      </div>
    </div>

    <div class="article-card__body mt-2">
      <USkeleton class="article-card__title" />
      <USkeleton class="article-card__title" />
      <USkeleton class="article-card__title" />
    </div>

    <USkeleton class="article-card__aside"/>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from "vue";

const props = defineProps({
  article: {type: Object as PropType<ArticleLocal>, required: false},
  type: { type: String as PropType<ArticleComponentType>, required: false, default: ArticleComponentType.DEFAULT },
})
import ArticleComponentType from "~/libs/constants/ArticleComponentType";
import type ArticleLocal from "~/libs/interfaces/ArticleLocal";

const articleClass = computed(() => {
  switch (props.type) {
    case ArticleComponentType.BIG:
      return 'article-card--big'
    case ArticleComponentType.MAIN:
      return 'article-card--big article-card--overlay'
    case ArticleComponentType.SEARCH:
      return 'article-card--search'
    case ArticleComponentType.RECOMMENDED:
      return 'article-card--recommended'
    case ArticleComponentType.DEFAULT:
    default:
      return ''
  }
})
</script>

<style scoped lang="postcss">

</style>